module.exports = __webpack_public_path__ + "assets/9d177220160e9c107adfae550bad91a8.mp3";